module.exports = __webpack_public_path__ + "img/img_factory.3ab4279c.png";